export default "<div class=\"no-data\">\r\n    <div class=\"text\">\r\n      Keine Daten vorhanden\r\n    </div>\r\n  </div>\r\n"